import React__default from 'react';
import { Button } from '@sravni/react-design-system/lib/Button';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { ArrowRight } from '@sravni/react-icons';
import '../ContextProvider/components/IsLoadingProvider/provider.js';
import { useIsLoading } from '../ContextProvider/components/IsLoadingProvider/hook.js';

const DEFAULT_CHILDREN = React__default.createElement(Icon, { size: 24, icon: React__default.createElement(ArrowRight, null) });
const SubmitButton = React__default.forwardRef((props, ref) => {
    const { children, size = 60, square, ...rest } = props;
    const isSquare = square && typeof size === 'number';
    const [isLoading] = useIsLoading();
    return (React__default.createElement(Button, { block: true, ref: ref, variant: "primary", color: "gray", ...rest, type: "submit", size: size, style: { ...(isSquare ? { height: `${size}px` } : {}) }, loading: isLoading, disabled: isLoading }, children || DEFAULT_CHILDREN));
});

export { SubmitButton };
//# sourceMappingURL=view.js.map
